/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Forced_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle forced subtitle" |
*
* @param {Event_Forced_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_forced_aria_label = /** @type {((inputs?: Event_Forced_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Forced_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le sous-titre force")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel erzwingen/umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva i sottotitoli forzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить/выключить принудительные субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar subtítulos forzados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换强制字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強制字幕の切り替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनिवार्य उपशीर्षक को चालू/बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/desativar legendas forçadas")
	return /** @type {LocalizedString} */ ("Toggle forced subtitle")
});